export default () => {
  return [
    {
      'id': 1,
      'title': 'Manus',
    },
    {
      'id': 2,
      'title': 'Regi',
    },
    {
      'id': 3,
      'title': 'Filmfoto',
    },
    {
      'id': 4,
      'title': 'Compositing',
    },
    {
      'id': 5,
      'title': 'Producent',
    },
    {
      'id': 6,
      'title': 'Delproducent',
    },
    {
      'id': 7,
      'title': 'Frontend-utvecklare',
    },
    {
      'id': 8,
      'title': 'Backend-utvecklare',
    },
    {
      'id': 9,
      'title': 'Originalare',
    },
    {
      'id': 10,
      'title': 'Grafisk Design',
    },
    {
      'id': 11,
      'title': 'Klippning',
    },
    {
      'id': 12,
      'title': 'Färgkorrigering',
    },
    {
      'id': 13,
      'title': '3D-modellering',
    },
    {
      'id': 14,
      'title': 'Animering',
    },
    {
      'id': 15,
      'title': 'Textur',
    },
    {
      'id': 16,
      'title': 'Bildretusch',
    },
    {
      'id': 17,
      'title': 'Studiofoto',
    },
    {
      'id': 18,
      'title': 'Modellfoto',
    },
    {
      'id': 19,
      'title': 'Ljussättning',
    },
    {
      'id': 20,
      'title': 'Riggning',
    },
    {
      'id': 21,
      'title': 'Ljudbearbetning',
    },
    {
      'id': 22,
      'title': 'Specialeffekter',
    },
    {
      'id': 23,
      'title': 'Bildkomposition',
    },
    {
      'id': 24,
      'title': 'Bildmanus',
    },
    {
      'id': 25,
      'title': 'Produktionsansvarig',
    },
    {
      'id': 26,
      'title': 'Illustration',
    },
    {
      'id': 27,
      'title': 'Produktoriginal',
    },
    {
      'id': 28,
      'title': 'Idé',
    },
    {
      'id': 29,
      'title': 'Projektledare',
    },
    {
      'id': 30,
      'title': 'Webmaster',
    },
    {
      'id': 31,
      'title': 'Webadministratör',
    },
    {
      'id': 32,
      'title': 'Produktfoto',
    },
    {
      'id': 33,
      'title': 'Content Marketing',
    },
    {
      'id': 34,
      'title': 'Camera tracking',
    },
    {
      'id': 35,
      'title': 'Ljudinspelning',
    },
    {
      'id': 36,
      'title': 'Ljudläggning och mix',
    },
    {
      'id': 37,
      'title': 'Grovklippning',
    },
    {
      'id': 38,
      'title': 'Flashprogrammering',
    },
    {
      'id': 39,
      'title': 'User Interface',
    },
    {
      'id': 40,
      'title': 'User Experience',
    },
    {
      'id': 41,
      'title': 'Mobilutveckling',
    }
  ];
};

